
/* eslint-disable react/no-unknown-property */

import React from 'react';
import PropTypes from 'prop-types';
import createCompanyHeaderParams from './createCompanyHeaderParams';

import './CompanyHeader.scss';

const CompanyHeader = ({
  params: {
    isUseHeader,
    headerAlign,
    companyHeaderUrl,
  },
  onLoad,
}) => {
  if (process.env.NODE_ENV !== 'production') {
    companyHeaderUrl = (
      url => ((~url.indexOf('http') || ~url.indexOf('data:image')) ? url : `${window.productionDomain}${url}`)
    )(companyHeaderUrl);
  }

  const backgroundSize = (process.env.BROWSER === 'ff' || process.env.BROWSER === 'ie') ? '32000' : '600000'; /* при 700000+ в хроме появляються артефакты */
  const stretchedPixelStyle = {
    backgroundImage: `url(${companyHeaderUrl})`,
    backgroundSize: `${backgroundSize}px 100%`,
  }

  return (
    isUseHeader && companyHeaderUrl
      ? (
        <div className={`company-header align-${headerAlign}`} onLoad={onLoad || null}>
          <div className="stretched-first-pixel" style={stretchedPixelStyle} />
          <img src={companyHeaderUrl} alt="" />
          <div className="stretched-last-pixel" style={stretchedPixelStyle} />
        </div>
      )
      : null
  );
};

if (process.env.NODE_ENV !== 'production') {
  CompanyHeader.propTypes = {
    params: PropTypes.shape({
      isUseHeader: PropTypes.bool,
      headerAlign: PropTypes.string,
      companyHeaderUrl: PropTypes.string,
    }).isRequired,
    onLoad: PropTypes.func,
  };
}
export { createCompanyHeaderParams };

export default CompanyHeader;
